/**
 * @fileoverview TransactionModalErrors - Displays validation and API errors for transaction modals.
 *
 * Shows all validation errors from transaction forms including field-level errors,
 * category errors, and general API/database errors.
 *
 * @description This component:
 * - Displays general errors (database errors, API failures)
 * - Shows field-specific validation errors (amount, description, date, etc.)
 * - Displays category-level errors with indices
 * - Handles both add and edit transaction error states
 *
 * @module components/TransactionModal/TransactionModalErrors
 */
import styles from './TransactionModalErrors.module.css';

function TransactionModalErrors({ errors }) {
    if (!errors || Object.keys(errors).length === 0) return null;

    return (
        <div className={styles.errorContainer}>
            {errors.general && <div className={styles.errorMessage}>{errors.general}</div>}
            {errors.transactionType && <div className={styles.errorMessage}>{errors.transactionType}</div>}
            {errors.currentUser && <div className={styles.errorMessage}>{errors.currentUser}</div>}
            {errors.amount && <div className={styles.errorMessage}>{errors.amount}</div>}
            {errors.description && <div className={styles.errorMessage}>{errors.description}</div>}
            {errors.date && <div className={styles.errorMessage}>{errors.date}</div>}
            {errors.adjustmentFromCategory && <div className={styles.errorMessage}>{errors.adjustmentFromCategory}</div>}
            {errors.adjustmentToCategory && <div className={styles.errorMessage}>{errors.adjustmentToCategory}</div>}
            {errors.adjustmentCategories && <div className={styles.errorMessage}>{errors.adjustmentCategories}</div>}
            {errors.categorySum && <div className={styles.errorMessage}>{errors.categorySum}</div>}
            {errors.categories && Object.keys(errors.categories).map(index => (
                <div key={index}>
                    {errors.categories[index].category && <div className={styles.errorMessage}>Category {parseInt(index) + 1}: {errors.categories[index].category}</div>}
                    {errors.categories[index].amount && <div className={styles.errorMessage}>Category {parseInt(index) + 1} Amount: {errors.categories[index].amount}</div>}
                </div>
            ))}
        </div>
    );
}

export default TransactionModalErrors;
